import '../css/news.less';
import '../css/themes.less';
import '../css/mediaQs.less';
import { changeTheme } from './modules/themeChange';
import { getHackerNews } from './modules/getHackerNews';
import { getMediaStack } from './modules/getMediaStack';
import { setDefaults } from './modules/setDefaults';
import { inputEventListeners, customSearchInputValue, fromDate, toDate, paginationCounter } from './modules/inputEventListeners';

export const fetchButton = document.getElementById('fetchNews');
export const requestFilterUrl = `${API_URL}` + `requestFilter`
export const mediaStackSourceUrl = `${API_URL}` + `mediaStackApi`;
export const hackerNewsSourceUrl = `${API_URL}` + `hackerNewsApi`;
export const blocker = document.getElementById('blocker');

const themeInput = document.getElementById("themeInput");

const leftColumnInput = document.getElementById("leftColumnInput");
const centerColumnInput = document.getElementById("centerColumnInput");
const rightColumnInput = document.getElementById("rightColumnInput");
const sources = document.getElementsByClassName('sourceOption');
const lcrMenus = document.getElementsByClassName('lcrMenu');
const datePickerInputs = document.getElementsByClassName('datePicker');

let filteredSources = [];
let lsEntries = [];

const resetFilters = () => {
    filteredSources.length = 0;
    lsEntries = Object.entries(localStorage)
}
const checkInputs = () => {
    resetFilters()
    if (fromDate > toDate) {
        $(datePickerInputs).addClass("invalid")
        return console.log("invalid dates")
    }
    $(datePickerInputs).removeClass("invalid")
    if (localStorage.guardian === undefined) {
        setDefaults();

    } else {
        
        for (let i of lsEntries) {
            filteredSources.push([i[0], i[1]]);

            switch (i[1]) {
                case "left":
                    for (let menu of lcrMenus) {
                        if (menu.children[0].id.slice(-1) === "L") {
                            if (i[0].substring(0, i[0].length - 4) === menu.children[0].id.substring(0, menu.children[0].id.length - 1)) {
                                menu.children[0].checked = true
                            }
                        }
                    }
                    break;
                case "center":
                    for (let menu of lcrMenus) {
                        if (i[0].substring(0, i[0].length - 4) === menu.children[2].id.substring(0, menu.children[2].id.length - 1)) {
                            menu.children[2].checked = true
                        }
                    }
                    break;
                case "right":
                    for (let menu of lcrMenus) {
                        if (i[0].substring(0, i[0].length - 4) === menu.children[4].id.substring(0, menu.children[4].id.length - 1)) {
                            menu.children[4].checked = true
                        }
                    }
                    break;
                case "true":
                    for (let j of sources) {
                        if (j.id === i[0]) {
                            i[0] === j.id ? j.checked = true : j.checked = false;
                        }
                    }
                    break;
                default:
                    break;
            }
        }
    }
}
checkInputs();
export const postRequestFilter = async () => {
    checkInputs();
    try {
        const response = await fetch(requestFilterUrl, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                data: {
                    filteredSources,
                    customSearchInputValue,
                    fromDate,
                    toDate,
                    paginationCounter
                }
            })
        })
        return response;
    } catch (error) {
        blocker.classList.remove('show')
        return console.log(error)
    }
}
export const gatherEmUp = async () => {
    try {
        await postRequestFilter();
        await getHackerNews();
        await getMediaStack();
        blocker.classList.remove('show')
    } catch (e) {
        blocker.classList.remove('show')
        alert("something has gone terribly wrong. most likely server fire.")
        return console.log(e);
    }
}
gatherEmUp()



let currentTheme = localStorage.getItem('themeToggle');
if (currentTheme === "dark") {
    changeTheme();
    themeInput.checked = true;
}
themeInput.addEventListener('change', () => {
    changeTheme();
})

let paginationButton = document.createElement("button");
paginationButton.classList.add('paginationButton');
paginationButton.innerHTML = ("More...")
leftColumn.insertAdjacentElement("beforeend", paginationButton.cloneNode(true));
centerColumn.insertAdjacentElement("beforeend", paginationButton.cloneNode(true));
rightColumn.insertAdjacentElement("beforeend", paginationButton.cloneNode(true));

if (localStorage.getItem('leftColumnVis') === "off") {
    document.querySelector('.leftColumn').classList.add('hide');
    document.getElementById('leftToggle').classList.add('disabled');
}
const leftVis = () => {
    if (localStorage.getItem('leftColumnVis') === "off") {
        localStorage.setItem('leftColumnVis', "on")
        document.querySelector('.leftColumn').classList.toggle('hide');
        document.getElementById('leftToggle').classList.toggle('disabled');
    } else {
        localStorage.setItem('leftColumnVis', "off")
        document.querySelector('.leftColumn').classList.toggle('hide');
        document.getElementById('leftToggle').classList.toggle('disabled');
    }
}
leftColumnInput.addEventListener('change', () => {
    leftVis();
})

if (localStorage.getItem('centerColumnVis') === "off") {
    document.querySelector('.centerColumn').classList.add('hide');
    document.getElementById('centerToggle').classList.add('disabled');
}
const centerVis = () => {
    if (localStorage.getItem('centerColumnVis') === "off") {
        localStorage.setItem('centerColumnVis', "on")
        document.querySelector('.centerColumn').classList.toggle('hide');
        document.getElementById('centerToggle').classList.toggle('disabled');
    } else {
        localStorage.setItem('centerColumnVis', "off")
        document.querySelector('.centerColumn').classList.toggle('hide');
        document.getElementById('centerToggle').classList.toggle('disabled');
    }
}
centerColumnInput.addEventListener('change', () => {
    centerVis();
})

if (localStorage.getItem('rightColumnVis') === "off") {
    document.querySelector('.rightColumn').classList.add('hide');
    document.getElementById('rightToggle').classList.add('disabled');
}
const rightVis = () => {
    if (localStorage.getItem('rightColumnVis') === "off") {
        localStorage.setItem('rightColumnVis', "on")
        document.querySelector('.rightColumn').classList.toggle('hide');
        document.getElementById('rightToggle').classList.toggle('disabled');
    } else {
        localStorage.setItem('rightColumnVis', "off")
        document.querySelector('.rightColumn').classList.toggle('hide');
        document.getElementById('rightToggle').classList.toggle('disabled');
    }
}
rightColumnInput.addEventListener('change', () => {
    rightVis();
})

inputEventListeners();
